var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgDownArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 170,
    viewBox: "0 0 65 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_5177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 -1.83366e-06L0 0L10.4873 10.4873L20.9746 -1.83366e-06Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 35.5391L0 35.5391L10.4873 46.0264L20.9746 35.5391Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 71.0937L0 71.0938L10.4873 81.581L20.9746 71.0937Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 106.633L0 106.633L10.4873 117.12L20.9746 106.633Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9746 142.168L0 142.168L10.4873 152.67L20.9746 142.168Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 17.2773L44.0254 17.2773L54.5127 27.7646L65 17.2773Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 52.832L44.0254 52.832L54.5127 63.3193L65 52.832Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 88.3711L44.0254 88.3711L54.5127 98.8584L65 88.3711Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 123.91L44.0254 123.91L54.5127 134.397L65 123.91Z",
    fill: "#0593A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 159.461L44.0254 159.461L54.5127 169.948L65 159.461Z",
    fill: "#0593A1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_5177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 169.949,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgDownArrow);
export default __webpack_public_path__ + "static/media/bg-down-arrow.e2d8b30c521700c0f86fe14ae8e594c0.svg";
export { ForwardRef as ReactComponent };